import * as React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslate } from "react-admin";
import {
  BannerFormValue,
  BannerPreview,
  LOCALE,
  SectionTitleLike,
  t,
} from "../creatorsShared/previewKit";
import { FaqItem, Translatable } from "../../types";

const SOFT_BG = "#FAF2EC";

interface FaqFormValue {
  sectionTitle?: Translatable<string>;
  sectionSubtitle?: Translatable<string>;
  faq?: Translatable<FaqItem[]>;
}

interface FaqPreviewFormValues {
  banner?: BannerFormValue;
  faq?: FaqFormValue;
}

const FaqListPreview = ({ faq }: { faq: FaqFormValue }) => {
  const items = faq?.faq?.[LOCALE] || [];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, py: 4 }}>
      <SectionTitleLike title={t(faq?.sectionTitle)} article={t(faq?.sectionSubtitle)} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
        }}
      >
        {items.map((item, index) => (
          <Accordion
            key={index}
            disableGutters
            sx={{ bgcolor: SOFT_BG, boxShadow: "none", "&:before": { display: "none" } }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{item?.question}</Typography>
            </AccordionSummary>
            <AccordionDetails
              dangerouslySetInnerHTML={{ __html: item?.answer || "" }}
            />
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

const FaqCreatorRender = ({ formData }: { formData: FaqPreviewFormValues }) => {
  const translate = useTranslate();
  const banner = formData?.banner || {};
  const faq = formData?.faq || {};

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: "block" }}>
        {translate("preview.metaHint")}
      </Typography>

      <Paper variant="outlined" sx={{ overflow: "hidden" }}>
        <BannerPreview banner={banner} />
        <Box sx={{ px: { xs: 3, md: 6 } }}>
          <FaqListPreview faq={faq} />
        </Box>
      </Paper>
    </Box>
  );
};

export default FaqCreatorRender;
